import {CA} from '../../analytics/Analytics'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {UIEndGameShareImage} from '../../ui_share_image/UIEndGameShareImage'
import {UIEndGameTitleImage} from '../../ui_share_image/UIEndGameTitleImage'
import {UIGameManager} from '../UIGameManager'
import {UIGameEndController} from './UIGameEndController'
import {ViewPopupShareImage} from '../../ui_popup/ViewPopupShareImage'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIGameEndShareButtonController {
    static shareImageDiscord?: (imageFile: File) => void
    private readonly uiGameManager: UIGameManager
    private readonly gameEndController: UIGameEndController

    private shareImage?: UIEndGameShareImage
    private readonly titleImage?: UIEndGameTitleImage

    private shareImagePopup: ViewPopupShareImage

    constructor(uiGameManager: UIGameManager, gameEndController: UIGameEndController) {
        this.uiGameManager = uiGameManager
        this.gameEndController = gameEndController

        if(this.gameEndController.endGamePlayerState?.title != null) {
            this.titleImage = new UIEndGameTitleImage(this.uiGameManager, this.gameEndController.endGamePlayerState.title, this.gameEndController.endGameState)
        }

        if(this.shouldShowShareGameResultsPopupAutomaticallyOnGameEnd()) this.createShareImagePopupIfNotExist(true)
    }

    onClickShare() {
        this.createShareImagePopupIfNotExist()

        UIGameEndShareButtonController.sendShareButtonClickAnalytic()
    }

    private createShareImagePopupIfNotExist(delay: boolean = false) {
        if(this.isPopupRemovedOrDoesNotExist()) {
            if(delay) {
                setTimeout(() => this.createShareImagePopupIfNotExist(), 3000)
                return
            }

            this.shareImage = new UIEndGameShareImage(this.uiGameManager, this.gameEndController.endGameState)
            this.shareImagePopup = this.titleImage ? new ViewPopupShareImage(this.titleImage, this.shareImage, true) : new ViewPopupShareImage(this.shareImage)

            if(UIGameEndShareButtonController.shareImageDiscord) {
                const shareAction = async(image: UIEndGameShareImage) => {
                    const imageFile = await image.getImageFile()
                    if(imageFile == undefined) return

                    UIGameEndShareButtonController.shareImageDiscord?.(imageFile)

                    UIGameEndShareButtonController.sendDiscordShareAnalytic()
                }

                this.shareImagePopup.setShareAction(shareAction)
            }
        }
    }

    private isPopupRemovedOrDoesNotExist(): boolean {
        if(this.shareImagePopup == undefined) return true
        if(this.shareImagePopup.isPopupRemoved()) return true
        return false
    }

    private shouldShowShareGameResultsPopupAutomaticallyOnGameEnd(): boolean {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return false
        if(this.uiGameManager.gameController.isReplay) return false
        return true
    }

    private static sendShareButtonClickAnalytic() {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }

    private static sendDiscordShareAnalytic() {
        const discordShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareDiscordButton,
        }
        void CA.sendAnalyticEventOnce(discordShareClickEvent)
    }
}
